import './App.css';
import { ReactComponent as React } from './icons/react-svgrepo-com.svg';
import { ReactComponent as Typescript } from './icons/typescript-icon-svgrepo-com.svg';
import { ReactComponent as NextJs } from './icons/next-dot-js-svgrepo-com.svg';
import { ReactComponent as Python } from './icons/python-svgrepo-com.svg';
import { ReactComponent as Javascript } from './icons/javascript-svgrepo-com.svg';
import { ReactComponent as Ruby } from './icons/rails-svgrepo-com.svg';
import { ReactComponent as GitHub } from './icons/github-svgrepo-com.svg';
import { ReactComponent as Linkedin } from './icons/linkedin-svgrepo-com.svg';
import { ReactComponent as Download } from './icons/download-minimalistic-svgrepo-com.svg';
import { ReactComponent as Sass } from './icons/sass-svgrepo-com.svg';
import { ReactComponent as Html } from './icons/html-5-svgrepo-com.svg';
import { ReactComponent as Docker } from './icons/docker-svgrepo-com.svg';
import { ReactComponent as Webpack } from './icons/webpack-svgrepo-com.svg';
import { ReactComponent as Cypress } from './icons/cypress-svgrepo-com.svg';
import { ReactComponent as Github } from './icons/github-142-svgrepo-com.svg';
import { ReactComponent as Angular } from './icons/angular-icon-svgrepo-com.svg';
import { ReactComponent as Tailwind } from './icons/tailwind-svgrepo-com.svg';
import { ReactComponent as Vue } from './icons/vue-svgrepo-com.svg';


import pdf from "./Sofia Stephenson_CV.pdf";
import { useState, useEffect, useRef } from 'react';

const scrollToSection = (e, sectionId) => {
  e.preventDefault();
  const element = document.querySelector(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export default function App() {
  const [isVisible, setIsVisible] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [trail, setTrail] = useState([]);
  const trailRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  // Mouse trail effect
  useEffect(() => {
    let animationFrameId;
    let lastTime = 0;
    const throttleDelay = 16; // ~60fps

    // Pink and purple color palette
    const colors = [
      '#ec4899', // pink-500
      '#f472b6', // pink-400
      '#f9a8d4', // pink-300
      '#fbcfe8', // pink-200
      '#8b5cf6', // purple-500
      '#a78bfa', // purple-400
      '#c4b5fd', // purple-300
      '#ddd6fe', // purple-200
      '#d946ef', // fuchsia-500
      '#e879f9', // fuchsia-400
      '#f0abfc', // fuchsia-300
      '#f5d0fe', // fuchsia-200
    ];

    const handleMouseMove = (e) => {
      const currentTime = Date.now();
      
      if (currentTime - lastTime < throttleDelay) {
        return;
      }
      lastTime = currentTime;

      // Randomly select a color from the palette
      const color = colors[Math.floor(Math.random() * colors.length)];

      const newParticle = {
        id: Date.now() + Math.random(),
        x: e.clientX,
        y: e.clientY,
        opacity: 1,
        color: color,
      };

      trailRef.current = [...trailRef.current, newParticle].slice(-15); // Keep last 15 particles
      setTrail([...trailRef.current]);

      // Fade out particles
      setTimeout(() => {
        trailRef.current = trailRef.current.filter(p => p.id !== newParticle.id);
        setTrail([...trailRef.current]);
      }, 600);
    };

    // Only enable on non-touch devices
    if (window.matchMedia('(pointer: fine)').matches) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  const handleMenuClick = (e, sectionId) => {
    scrollToSection(e, sectionId);
    setIsMenuOpen(false);
  };

  return (
    <div className="landing-page">
      {/* Mouse Trail */}
      {trail.map((particle) => (
        <div
          key={particle.id}
          className="mouse-trail-particle"
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
            backgroundColor: particle.color,
            boxShadow: `0 0 10px ${particle.color}80, 0 0 20px ${particle.color}60`,
          }}
        />
      ))}
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">Sofia Stephenson</div>
          <div className="nav-links">
            <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')}>Home</a>
            <a href="#about" onClick={(e) => scrollToSection(e, '#about')}>About</a>
            <a href="#skills" onClick={(e) => scrollToSection(e, '#skills')}>Skills</a>
            <a href="#projects" onClick={(e) => scrollToSection(e, '#projects')}>Projects</a>
            <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Contact</a>
          </div>
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <div className={`mobile-dropdown ${isMenuOpen ? 'open' : ''}`}>
            <a href="#hero" onClick={(e) => handleMenuClick(e, '#hero')}>Home</a>
            <a href="#about" onClick={(e) => handleMenuClick(e, '#about')}>About</a>
            <a href="#skills" onClick={(e) => handleMenuClick(e, '#skills')}>Skills</a>
            <a href="#projects" onClick={(e) => handleMenuClick(e, '#projects')}>Projects</a>
            <a href="#contact" onClick={(e) => handleMenuClick(e, '#contact')}>Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="hero">
        <div className="hero-content">
          <div className="hero-image">
            <div className="image-wrapper">
              <img 
                src="/ed2ce59c-49d4-4294-9552-f15d813efd20-compressed.png" 
                alt="Sofia Stephenson" 
                className="portrait-img"
              />
            </div>
          </div>
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="gradient-text">Sofia Stephenson</span>
            </h1>
            <h2 className="hero-subtitle">Frontend AI Engineer</h2>
            <p className="hero-description">
              Building beautiful, scalable applications with React, TypeScript, and AI-powered solutions
            </p>
            <div className="hero-cta">
              <a 
                href="#projects" 
                className="btn btn-primary"
                onClick={(e) => scrollToSection(e, '#projects')}
              >
                View My Work
              </a>
              <a 
                href={pdf} 
                download="Sofia Stephenson - CV 2026 (1).pdf"
                className="btn btn-secondary"
              >
                <Download className="btn-icon" />
                Download Resume
              </a>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <div className="mouse"></div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className={`about-section ${isVisible.about ? 'visible' : ''}`}>
        <div className="container">
          <h2 className="section-title">About Me</h2>
          <div className="about-content">
            <div className="about-text">
              <p className="about-intro">
                I am a highly experienced Frontend engineer with expertise in AI Machine Learning. 
                I build beautiful, scalable, mobile-first React, TypeScript, JavaScript and Next.js 
                applications, as well as intelligent chatbots, train models, and intelligent 
                synthesizes of data.
              </p>
              <div className="about-details">
                <h3>Professional Experience</h3>
                <p>
                  As a Frontend and AI engineer, I have developed super-intelligent chatbots for 
                  my company's customer service needs and for my own personal projects. I deliver 
                  high-performance, user-centric features using React, modernized legacy systems 
                  with TypeScript, and collaborate closely with cross-functional teams to deliver 
                  fast, measurable outcomes.
                </p>
                <p>
                  My work includes designing robust A/B testing experiments, building and iterating 
                  on user-facing flows, integrating headless CMS systems, and modernizing core 
                  codebases to enable long-term scalability. I am passionate about creating engaging, 
                  interactive experiences, driving data-informed UX improvements, and delivering 
                  reliable, high-quality products for global audiences.
                </p>
              </div>
            </div>
            <div className="about-image">
              <img 
                src="/—Pngtree—human brain neural network connections_21128488.png" 
                alt="Neural Network" 
                className="neural-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section id="skills" className={`skills-section ${isVisible.skills ? 'visible' : ''}`}>
        <div className="container">
          <h2 className="section-title">Technologies & Skills</h2>
          <div className="skills-grid">
            <div className="skill-card">
              <React className="skill-icon" />
              <h3>React</h3>
            </div>
            <div className="skill-card">
              <Typescript className="skill-icon" />
              <h3>TypeScript</h3>
            </div>
            <div className="skill-card">
              <NextJs className="skill-icon" />
              <h3>Next.js</h3>
            </div>
            <div className="skill-card">
              <Javascript className="skill-icon" />
              <h3>JavaScript</h3>
            </div>
            <div className="skill-card">
              <Python className="skill-icon" />
              <h3>Python</h3>
            </div>
            <div className="skill-card">
              <Ruby className="skill-icon" />
              <h3>Ruby on Rails</h3>
            </div>
            <div className="skill-card">
              <Sass className="skill-icon" />
              <h3>SASS</h3>
            </div>
            <div className="skill-card">
              <Html className="skill-icon" />
              <h3>HTML</h3>
            </div>
            <div className="skill-card">
              <Docker className="skill-icon" />
              <h3>Docker</h3>
            </div>
            <div className="skill-card">
              <Cypress className="skill-icon" />
              <h3>Cypress</h3>
            </div>
            <div className="skill-card">
              <Webpack className="skill-icon" />
              <h3>Webpack</h3>
            </div>
            <div className="skill-card">
              <Github className="skill-icon" />
              <h3>Github</h3>
            </div>
            <div className="skill-card">
              <Angular className="skill-icon" />
              <h3>Angular</h3>
            </div>
            <div className="skill-card">
              <Tailwind className="skill-icon" />
              <h3>Tailwind</h3>
            </div>
            <div className="skill-card">
              <Vue className="skill-icon" />
              <h3>Vue.js</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className={`projects-section ${isVisible.projects ? 'visible' : ''}`}>
        <div className="container">
          <h2 className="section-title">Featured Projects</h2>
          <div className="projects-grid">
            <div className="project-card">
              <a 
                href="https://huggingface.co/spaces/sgandsteph1/ChatDegrassTyson" 
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/chatdegrasstyson.png" 
                    alt="ChatDegrassTyson" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>ChatDegrassTyson</h3>
                  <p>
                    A super intelligent science chatbot trained on YouTube videos of the podcast 
                    "StarCast" by Neil Degrasse Tyson. Built with Python, Langchain, Whisper, 
                    Pinecone DB, OpenAI, and deployed through Gradio and Huggingface.
                  </p>
                </div>
              </a>
            </div>
            <div className="project-card">
              <a 
                href="https://www.spreadshirt.de/" 
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/spreadshirt.png" 
                    alt="SpreadShirt" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>SpreadShirt Homepage</h3>
                  <p>
                    Built with React.js, Next.js, TypeScript, SCSS, and Freemarker.
                  </p>
                </div>
              </a>
            </div>
            <div className="project-card">
              <a 
                href="https://www.spreadshop.de/" 
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/spreadshop.png" 
                    alt="Spreadshop" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>Spreadshop Homepage</h3>
                  <p>
                    Built with React.js, Next.js, TypeScript, SCSS, and Amplience Headless CMS.
                  </p>
                </div>
              </a>
            </div>
            <div className="project-card">
              <a 
                href="https://playportfolio.sofiastephengineer.com/"
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/playportfolio.png" 
                    alt="Portfolio" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>Sofia Stephenson Play Portfolio</h3>
                  <p>
                    A single page React.js App, built with SCSS, SCSS animations, Hostinger Web Server.
                  </p>
                </div>
              </a>
            </div>
            <div className="project-card">
              <a 
                href="https://beatles-anthology.sofiastephengineer.com/" 
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/beatles.png" 
                    alt="Beatles Anthology" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>Beatles Anthology</h3>
                  <p>
                    Built with Angular.js, SCSS, and ITunes API.
                  </p>
                </div>
              </a>
            </div>
            <div className="project-card">
              <a 
                href="https://sepidehkaav.com/"
                target="_blank" 
                rel="noreferrer"
                className="project-link"
              >
                <div className="project-image">
                  <img 
                    src="/sep-portfolio.png" 
                    alt="Portfolio" 
                  />
                  <div className="project-overlay">
                    <span className="project-link-text">View Project →</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>Sepideh Kaav Comedian Website</h3>
                  <p>
                    A single page React.js App, built with SCSS, SCSS animations, with fully functional mailing list, and deployed through Hostinger Web Server.
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className={`contact-section ${isVisible.contact ? 'visible' : ''}`}>
        <div className="container">
          <h2 className="section-title">Get In Touch</h2>
          <div className="contact-content">
            <p className="contact-email">Email: sgandsteph@gmail.com</p>
            <div className="social-links">
              <a 
                href="https://www.linkedin.com/in/sofiags/" 
                target="_blank" 
                rel="noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <Linkedin className="social-icon" />
                <span>LinkedIn</span>
              </a>
              <a 
                href="https://github.com/steph-crypt" 
                target="_blank" 
                rel="noreferrer"
                className="social-link"
                aria-label="GitHub"
              >
                <GitHub className="social-icon" />
                <span>GitHub</span>
              </a>
              <a 
                href={pdf} 
                download="Sofia Stephenson - CV 2026 (1).pdf"
                className="social-link"
                aria-label="Download Resume"
              >
                <Download className="social-icon" />
                <span>Resume</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Sofia Stephenson. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
